var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtillery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.471 10.998a2.326 2.326 0 0 0-2.931-.215 2.34 2.34 0 0 0-.57 3.243 2.326 2.326 0 0 0 2.834.8q.207-.093.399-.228a2.34 2.34 0 0 0 .57-3.243q-.136-.196-.302-.357m-.692.724a1.33 1.33 0 0 0-1.666-.117 1.333 1.333 0 0 0-.324 1.846 1.33 1.33 0 0 0 1.61.457 1.333 1.333 0 0 0 .554-1.978 1.5 1.5 0 0 0-.174-.208",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.726 2.707a.65.65 0 0 0 .154-.907L14.812.282a.655.655 0 0 0-.908-.166l-1.879 1.31a1.55 1.55 0 0 0-.634 1.573l-3.1 2.154-.198-.285A1.07 1.07 0 0 0 6.6 4.604L.457 8.919a1.3 1.3 0 0 0-.276.283c-.239.358-.248.84.013 1.214l.049.07a3.5 3.5 0 0 1 .582-.513l.201-.132a3.52 3.52 0 0 1 4.238.457c.165.162.32.345.456.54q.246.355.395.741l.004.01c.133.346.208.705.229 1.065l3.94-2.767c.484-.34.602-1.011.263-1.497L9.043 6.23l3.102-2.158q.04.024.08.044c.504.262 1.13.244 1.622-.1zM9.708 9.056a.06.06 0 0 0 .015-.085L7.265 5.45a.06.06 0 0 0-.085-.015L3.063 8.327A4.501 4.501 0 0 1 5.959 9.56l.004.005.006.005a4.8 4.8 0 0 1 .993 1.414zm2.947-5.847-.232-.138-.056-.294a.55.55 0 0 1 .229-.528l1.594-1.112.67.952-1.584 1.104a.57.57 0 0 1-.621.016",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtillery);
export default __webpack_public_path__ + "static/media/artillery.e857dfd0ab1fdfe05450c7f7a3cc878c.svg";
export { ForwardRef as ReactComponent };